<template>
  <keep-alive include="ReimbursementTab">
    <component :is="currentComponent" :isFinance='isFinance' :ID='ID' @toggle='toggle' />
  </keep-alive>
</template>
<script>
import AddReimbursement from "./addReimbursement.vue";
import ReimbursementTab from "./tabs.vue";
import ReimbursementDetail from "./reimbursementDetail.vue";
import { basic } from "../../http/api";
export default {
  name: "reimbursementList",
  components: { AddReimbursement, ReimbursementTab, ReimbursementDetail },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      isFinance: false,
      currentComponent: '',
      ID: null
    }
  },
  created() {
    this.getBgUser()
  },
  methods: {
    toggle(data) {
      this.currentComponent = data.name;
      this.ID = data && data.row && data.row.ID;
    },
    getBgUser() {
      basic('BgUser', 'Get', { key: this.userInfo.UserId }).then(res => {
        this.isFinance = res && res.OrgStructure.DepartmentType === 4;
        this.currentComponent = 'ReimbursementTab'
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>